import { useFeatureIsOn as _useFeatureIsOn } from '@growthbook/growthbook-react';
import { IGrowthBookFeatures } from './growthbook.interfaces';

export const useFeatureIsOn = (id: keyof IGrowthBookFeatures): boolean => _useFeatureIsOn<IGrowthBookFeatures>(id);
